import React from 'react';
import WebpackerReact from 'webpacker-react';
import ClientsIndex from '../components/admin/Clients/ClientsIndex';

const ClientsV2Index = (props) => <ClientsIndex {...props} />;

export default ClientsV2Index;
WebpackerReact.setup({ ClientsV2Index });
